<template>
  <span class="edit-delete-issue-button">
    <div class="action edit">
      <v-icon @click="editIssue()">edit</v-icon>
    </div>
    <div class="action delete">
      <v-icon @click="deleteIssue">delete_outline</v-icon>
    </div>
  </span>
</template>

<script>

export default {
  name: 'EditDeleteIssueButton',
  props: {
    issue: {
      type: Object,
      required: true,
    },
  },
  methods: {
    editIssue() {
      this.$emit('editIssueClicked', this.issue);
    },
    deleteIssue() {
      this.$emit('deleteIssueClicked', this.issue.id);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.action {
  display: inline-block;
  padding: rem(2);
  border-radius: $radius-sm;
}

.edit {
  background-color: rgba(77, 159, 235, 0.18);
  .v-icon {
    color: #4D9FEB;
  }
}
.delete {
  margin-left: $space-3;
  background-color: $severity-critical-bg;
  .v-icon {
    color: $severity-critical;
  }
}
</style>
